import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { Scheduler, SchedulerData } from 'src/app/model/schedulers-data';
import { Client } from 'src/app/model/client';
import { Project } from 'src/app/model/project';
import { SchedulerTarget } from 'src/app/model/schedulers-target';
import { ClientService } from 'src/app/service/client.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ProjectService } from 'src/app/service/project.service';
import { SchedulerService } from 'src/app/service/scheduler.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-assigntarget-modal',
  templateUrl: './assigntarget-modal.component.html',
  styleUrls: ['./assigntarget-modal.component.scss']
})
export class AssigntargetModalComponent implements OnInit {
  _assignTarget: FormGroup;
  clients: Client[];
  selectedClient: string;
  projects: Project[];
  project: Project;
  selectedProject: string;
  schedulerTargetRequest: SchedulerTarget;
  startDate: Date;
  endDate: Date;

  rangeFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }

  constructor(private _formBuilder: FormBuilder,
    private clientService: ClientService,
    private projectService: ProjectService,
    private schedulerService: SchedulerService,
    private datePipe: DatePipe,
    private _localStorage: LocalStorageService,
    private _notificationService: NotificationService,
    public dialogRef: MatDialogRef<AssigntargetModalComponent>,
    @Inject(MAT_DIALOG_DATA) public assignedScheduler: Scheduler) { }

  ngOnInit(): void {
    this.getClientList();
    if (this.assignedScheduler.isAssigned) {
      this.selectedClient = this.assignedScheduler.clientId;
      this.getProjects(this.selectedClient);
      this.selectedProject = this.assignedScheduler.projectId;
      //this.getSchedulers(this.selectedProject)
      this._assignTarget = this._formBuilder.group({
        selectedClient: new FormControl({ value: this.selectedClient, disabled: true }),
        selectedProject: new FormControl({ value: this.selectedProject, disabled: true }),
        targetCalls: new FormControl(''),
        targetSchedules: new FormControl(''),
      });
    }
  }

  getClientList() {
    this.clientService.getClients().subscribe(result => {
      if (!result) {
        return;
      }
      this.clients = result.clients;
      console.log("Client Name: " + this.clients[0].clientName);
    }, error => console.log(error));
  }

  getProjectsByClient({ value }) {
    //alert(value);
    this.getProjects(value);
  }

  getProjects(value: string) {
    //alert(value);
    this.projectService.getProjects(value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this.projects = result.projects;
        this.selectedProject = this.assignedScheduler.projectId;
        console.log("projects: " + this.projects);
      }, error => console.log(error));
  }

  onSubmit() {
    this.schedulerTargetRequest = this._assignTarget.value;
    this.schedulerTargetRequest.schedulers = [];
    //this.assignedSchedulers.filter(item => {
    this.schedulerTargetRequest.schedulers.push(this.assignedScheduler);
    //})
    //this.assignSchedulerRequest.projectId = this._localStorage.retrieve("project").projectId;
    this.schedulerTargetRequest.projectId = this.assignedScheduler.projectId;
    this.schedulerTargetRequest.updatedBy = this._localStorage.retrieve('profile').displayName;
    //alert(this.assignSchedulerRequest.schedulers[0].schedulerName+'<>'+this.assignSchedulerRequest.projectId);
    /* this.assignSchedulerRequest.schedulers.filter(item => {
      alert(item.schedulerId + "<->" + item.schedulerName);
    }) */
    console.log(this.schedulerTargetRequest.fromDate + ' - ' + this.schedulerTargetRequest.toDate);
    //this.convertToTimezone(this.dateRange.timeZone);
    this.schedulerTargetRequest.fromDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd").toString();
    this.schedulerTargetRequest.toDate = this.datePipe.transform(this.endDate, "yyyy-MM-dd").toString();
    console.log(this.schedulerTargetRequest.fromDate + ' - ' + this.schedulerTargetRequest.toDate);
    //alert(this.schedulerTargetRequest.targetCalls);
    this.schedulerService.assignSchedulersTarget(this.schedulerTargetRequest)
      .subscribe(result => {
        if (!result) {
          return;
        }
        console.log(result);
        this._notificationService.success('Assigned target successfully');
        this.dialogRef.close(this._assignTarget.value);
      }, error => console.log(error));
  }

  dateChangeEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    console.log(`${type}: ${event.value}`);
    if (type === 'startDate') {
      if (event.value) {
        console.log('StartDate...');
        this.startDate = event.value;
      }
    }
    if (type === 'endDate') {
      if (event.value) {
        console.log('EndDate...');
        this.endDate = event.value;
        //this.onDateChange();
      }
    }
  }
}
